import { useMemo } from 'react';

import { LogActivityForm } from '#components/organisms/forms/LogActivityForm';
import { getErrorMessage_v2, toTitleCase } from 'core/Utils';
import { ButtonMantine, Modal, notifications } from 'ui';

import { useUpdateParticipantActivityLog } from '../../../../api/new/campaigns/peers/update';
import { useActivityLogForm, useLogActivityModalProvider } from './LogActivityModalFlow';

const LogActivityModalFooter = () => {
  const { openModalById, meta, closeAllModals } = useLogActivityModalProvider({});
  const form = useActivityLogForm();

  const { mutate: updateParticipantActivityLog, isPending: isUpdatingParticipant } =
    useUpdateParticipantActivityLog();

  const activityLog = {
    value: form?.values?.value ?? 0,
    date: form?.values?.date ? form?.values?.date?.toISOString() : '',
  };

  const handleSuccess = () => {
    if (meta.onSuccess) {
      meta.onSuccess();
      closeAllModals();
    } else {
      openModalById('success');
    }
    form.reset();
  };

  const participantActivityLog = useMemo(() => {
    if (form.values.index !== undefined) {
      return meta.participant.activity_log.filter((_, i) => i !== form.values.index);
    }
    return meta.participant.activity_log;
  }, [form.values.index, meta.participant.activity_log]);

  const handleSubmit = () => {
    if (!form.validate().hasErrors) {
      updateParticipantActivityLog(
        {
          campaignId: meta.campaignId,
          causeId: meta.causeId,
          participantId: meta.participant.uuid,
          activityLog: [...participantActivityLog, activityLog],
        },
        {
          onSuccess() {
            handleSuccess();
          },
          onError(e) {
            notifications.show({
              variant: 'error',
              message: getErrorMessage_v2(e),
            });
          },
        }
      );
    }
  };

  return (
    <Modal.AffixedFooter>
      <ButtonMantine fullWidth onClick={handleSubmit} loading={isUpdatingParticipant}>
        Submit Activity
      </ButtonMantine>
    </Modal.AffixedFooter>
  );
};

const LogActivityModal = () => {
  const { opened, close, meta } = useLogActivityModalProvider({
    id: 'base',
  });
  const form = useActivityLogForm();

  const handleClose = () => {
    form?.reset();
    close();
  };

  const title = useMemo(() => {
    if (form.values.index !== undefined)
      return `Edit Logged ${toTitleCase(meta.unitsOfActivity ?? 'activity')}`;
    else {
      return `Log Activity`;
    }
  }, [form.values.index, meta.unitsOfActivity]);

  return (
    <Modal opened={opened} onClose={handleClose} title={title}>
      <LogActivityForm />
      <LogActivityModalFooter />
    </Modal>
  );
};

export { LogActivityModal };
